<template>

  <div class="mydayPowerQuality">
    <div class="con">
      <div class="tree-left">
        <elUnitTree @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>
      </div>
      <div class="right-table">
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small mr-20">
                <div class="select">
                  <div class="span" :class="{'active':selectDate_index == i}" v-for="(e ,i) in selectDate"
                    @click="selectDate_fn(i)">{{e}}</div>
                </div>
              </div>
              <div class="input-small">
                <span>日期：</span>
                <el-date-picker v-model="yearTimer" type="date" placeholder="选择日期"
                  :picker-options="pickerOptions"></el-date-picker>
              </div>
              <el-button type="primary" plain @click="getSearch" class="search-btn">查询</el-button>
            </div>
          </el-scrollbar>


        </div>
        <div class="mychart" :style="{'width':'100%','height':`${chartHeights}px`}">
          <div id="proportion" style="width:100%;height:100%"></div>
        </div>

        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import elUnitTree from '@/components/module/newTree/elDeviceTree.vue'
  import {getCountPower} from "../../api/abbNewApi";
  let proportion;
  export default {
    components: {
      elUnitTree
    },
    props: [],
    data () {
      return {
        selectDate: ['整体能耗','各项目能耗','同环比分析',],
        selectDate_index: 2,
        loading: false,
        chartHeights: Math.round((document.getElementById('app').clientHeight)*0.81),
        tabHeights: Math.round((document.getElementById('app').clientHeight)*0.28),
        vchartDate: [],
        nowVirtualDevice: undefined,
        nowApptypeGroups: [],
        dataObject: {},
        totalSize: 0,
        nowIndex: 0,
        options: {},
        from2name: {},
        apptypeValue: ['voltageUnbalance'],
        yearTimer: new Date(),
        dataList: [],
        proportionData: {
          grid: {
            left: '3%',
            right: '3%',
            bottom: '8%',
            containLabel: true
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          toolbox: {
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            right: "35",
            top: "20",
            feature: {
              magicType: {
                type: ['line','bar','stack','tiled'],title: {
                  line: '切换为折线图',
                  bar: '切换为柱状图',
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },
              saveAsImage: {
                show: true,
                title: '下载图片'
              },
              // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
            },
            tooltip: { // 和 option.tooltip 的配置项相同
              show: true,
              formatter: function(param) {
                return '<div>'+param.title+'</div>'; // 自定义的 DOM 结构
              },
              backgroundColor: '#fff',
              textStyle: {
                fontSize: 12,
              },
              extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' // 自定义的 CSS 样式
            }
          },
          legend: {
            type: 'scroll',
            top: 10,
            tooltip: {
              show: true
            },
          },
          xAxis: {
            splitLine: {
              //网格线
              show: true,
            },
            type: "category",

            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,

            },
            axisLine: {
              show: false,
            },
            z: 99,
            data: [],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: 'A栋一层低压配电站',

              data: [120,200,150,80,70,110,130,120,200,150,80,70,110,130],
              type: 'bar',
              barGap: 0,
            },
            {
              name: 'A栋二层低压配电站',

              data: [120,200,150,80,70,110,130,120,200,150,80,70,110,130],
              type: 'bar',
              barGap: 0,
            },
            {
              name: 'A栋三层低压配电站',

              data: [120,200,150,80,70,110,130,120,200,150,80,70,110,130],
              type: 'bar',
              barGap: 0,
            },
            {
              name: 'A栋四层低压配电站',

              data: [120,200,150,80,70,110,130,120,200,150,80,70,110,130],
              type: 'bar',
              barGap: 0,
            },
          ],
        },
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
        },
        copynowVirtualDevice: [],
        mynum: 1
      }
    },
    mounted () {
      for(let i=0;i<=23;i++) {
        this.proportionData.xAxis.data.push(i+':00')
      }
      //初始化图表
      this.init();
    },
    computed: {
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        // console.log("树形结构",data);
        return isempty(data)? []:[deviceList(data)]
      },

      variableTree () {
        if(this.nowVirtualDevice==undefined) {
          return []
        }
        return this.$store.variableStore.getters.getVariableTree(this.nowVirtualDevice.no)
      },
      nowVariableNames () {
        //当前应该显示的变量fromname列表
        var ag=[]
        for(var i=0,len=this.nowApptypeGroups.length;i<len;i++) {
          var item=this.nowApptypeGroups[i]
          if(item.id==-1||item.id==-2) {
            ag=ag.concat(item.next.map(ni => {
              return ni.id
            }))
          } else {
            ag.push(item.id)
          }
        }
        var v1=this.variableTree.filter(item => {
          return ag.includes(item.no)
        })
        if(isempty(v1)) {
          return []
        }
        var v2=[]
        v1.forEach(item => {
          item.next.forEach(i => {
            v2.push(i.fromName) //fromName
          })
        })
        return v2
      },
      apptypeGroups () {
        // console.log("下拉框",this.$store.variableStore.state.powerApptypeGroup);
        return this.$store.variableStore.state.powerApptypeGroup
      },
      nowShowDataList () {
        //当前应该显示的数据列表
        var list=[]
        //只取出要显示的变量的数据
        for(var i=0,len=this.nowVariableNames.length;i<len;i++) {
          var item=this.dataObject[this.nowVariableNames[i]]
          if(!isempty(item)) {
            if(parseFloat(item)!==NaN) {
              if(isnull(parseFloat(item))) {
                item=undefined
              }
            }
            list.push(item)
          }
        }
        return list
      },
      columns () {
        //列表的项，每个整点值
        var list=[]
        // list.push({
        // 	name: "名称"
        // })
        for(var i=1;i<32;i++) {
          list.push({
            al: 'center',
            key: i+'月',
            name: i+'月'
          })
        }
        return list
      },
      nowPage () {
        //按照页码来返回当前应该显示的列表
        var list=[]
        var baseList=this.nowShowDataList.filter((item,index) => {
          return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
        })
        //排练数据，名称在第一个，后面按顺序显示数据
        for(var i=0,len=baseList.length;i<len;i++) {
          var item=baseList[i][0]
          if(!isempty(item)) {
            var vlist=[]
            var name=this.from2name[item.variablename]? this.from2name[item.variablename]:item.variablename
            vlist.push(name.subByFirstChar('.'))
            //取整点值
            for(var i2=0,len2=item.data.length;i2*12<len2;i2++) {
              var item2=item.data[i2*12]
              if(isNaN(parseFloat((item2)))||isnull(parseFloat((item2)))) {
                item2=undefined
              }
              vlist.push(item2)
            }
            list.push(vlist)
          }
        }
        return list
      },
      allVariableName () {
        //所有的通讯变量名称
        var list=[]
        for(var i=0,len=this.variableTree.length;i<len;i++) {
          var next=this.variableTree[i].next
          for(var i2=0,len2=next.length;i2<len2;i2++) {
            var item=next[i2]
            this.from2name[item.fromName]=item.name
            list.push(item.fromName) //fromName
          }
        }
        return list
      },
      pageLen () {
        return this.nowVariableNames.length<6? 6:this.nowVariableNames.length
      }
    },
    watch: {
      nowDevice (nv,ov) {
        this.dataObject={}
      },
      nowShowDataList (nv,ov) {
        //获取到新的数据了，重新渲染 
        this.nowIndex=0
      },
      allVariableName (nv,ov) {
        this.search()
      },

      copynowVirtualDevice (val) {
        this.mynum+=1
        if(this.mynum==2) {
          this.nowVirtualDevice=val
        }
      }
    },
    methods: {
      selectDate_fn (v) {
        console.log(v);
        if(v===0) {
          this.$router.push("/statistics")
        }
        if(v===1) {
          this.$router.push("/each")
        }
        if(v===2) {
          this.$router.push("/proportion")
        }
      },
      checkFun (val) {
        this.copynowVirtualDevice=val;
      },
      getSearch () {
        this.nowVirtualDevice=this.copynowVirtualDevice
        this.search()
      },
      //新下拉框
      selectAll () {
        //全选 先判断是否有选中的，有选中就清空
        if(this.apptypeValue.length==1) {
          this.nowApptypeGroup=this.apptypeGroups
          let idList=[]
          let valueList=[]
          this.apptypeGroups.forEach(item => {
            idList.push(item.id)
            valueList.push(item.value)
          })
          this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',idList)
          this.apptypeValue=valueList

        } else {
          this.nowApptypeGroup=[]
          this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',[])
          this.apptypeValue=[]
        }
      },

      search () {




        return



      },
      exportExcel () {

      },
      init () {
        proportion=echarts.init(document.getElementById("proportion"));
        proportion.setOption(this.proportionData,true);



      },


    }
  }
</script>

<style scoped lang="scss">
  .select {
    display: flex;
    border: 1px solid #C0C4CC;
    border-right: none;
  }

  .select .span {
    border-right: 1px solid #C0C4CC;
    width: 170px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
  }

  .select .active {
    background: #ba0f1b;
    color: #fff;
  }

  .mydayPowerQuality {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .search-input-btn {
        margin-bottom: 0px;
      }

      .tree-left {
        width: 3rem;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: calc(100% - 3.08rem);
        height: 100%;
        padding: 2px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;
      }
    }
  }
</style>